export default __webpack_public_path__ + "static/media/gift5.74a21a77.png";